document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });



    /////// Reviews Quad  //////////
    let quadReviews = new Swiper('.reviews-block__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next'
        }
    });

    //////// Slider Room /////
       let quadSlider = new Swiper('.slider-room__slider',{
            loop: true,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                prevEl: '.slider-prev',
                nextEl: '.slider-next'
            }
        });

      let tagSlider = new Swiper('.tabs-block__slider',{
            loop: true,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            navigation: {
                prevEl: '.tabs-bg-prev',
                nextEl: '.tabs-bg-next'
            }
        });

      let quadGallery = new Swiper('.gallery-one__slider',{
            speed: 700,
            centeredSlides: true,
            loop:true,
            initialSlide: 1,
            breakpoints: {
                320: {
                    spaceBetween: 15,
                    slidesPerView: 1.2,
                    navigation: false
                },
                900:{
                    spaceBetween: 30,
                    slidesPerView: 1.5,
                    navigation: {
                        prevEl: '.gallery-one-prev',
                        nextEl: '.gallery-one-next'
                    }
                }
            }
    })
});